import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { string, object } from "prop-types";

import "./icons.m.css";

if (require.context) {
  const req = require.context("../../../assets/icons/", true, /\.svg$/);
  req.keys().forEach((filename) => req(filename));
}

const IconBase = ({
  type,
  className = "",
  iconSpritePath,
  iconStyle = {},
  datatrackingcategory,
  datatrackingaction,
  datatrackinglabel,
}) => {
  if (!type) return null;
  return (
    <svg
      className={className}
      styleName="svg-icon"
      style={iconStyle}
      data-tracking-category={datatrackingcategory}
      data-tracking-action={datatrackingaction}
      data-tracking-label={datatrackinglabel}
    >
      <use href={`${iconSpritePath}#${String(type).toLowerCase()}`} />
    </svg>
  );
};

const mapStateToProps = (state) => ({
  iconSpritePath: get(state, ["qt", "config", "iconSpritePath"]),
});

IconBase.propTypes = {
  type: string,
  className: string,
  iconSpritePath: string,
  iconStyle: object,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export const Icon = connect(mapStateToProps)(IconBase);

export default Icon;
